export interface SortDescriptor<Item> {
    column: keyof Item;
    direction: 'asc' | 'desc';
}

export const toggleSortDescriptor = <Item>(
    previousDescriptor: SortDescriptor<Item> | null,
    column: keyof Item,
): SortDescriptor<Item> => {
    return {
        column,
        direction:
            column === previousDescriptor?.column &&
            previousDescriptor?.direction === 'desc'
                ? 'asc'
                : 'desc',
    };
};

export const createSortFn = <Item>(sortDescriptor: SortDescriptor<Item>) => {
    return (a: Item, b: Item) => {
        const first = a[sortDescriptor.column];
        const second = b[sortDescriptor.column];

        let cmp =
            (Number(first) || first) < (Number(second) || second) ? -1 : 1;

        if (sortDescriptor.direction === 'desc') {
            cmp *= -1;
        }

        return cmp;
    };
};
